<script>
  import { afterUpdate } from "svelte"
  import { loadTooltip } from "../../../../Script/loadTooltip"
  import BadgePublish from "../../../Publish/Badge/Stores/badge"

  export let json

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<div class="relative mx-auto mt-3 flex h-full w-full flex-col gap-3 rounded-r-md border-l-8 border-green-500 bg-white px-6 py-3 hover:shadow-md dark:border-y-2 dark:border-r-2 dark:border-y-transparent dark:border-r-transparent dark:bg-lightgray dark:hover:border-green-500">
  <div class="flex w-full items-center justify-between gap-6">
    <div class="space-y-1.5 truncate">
      <div class="flex flex-col truncate sm:flex-row sm:items-center sm:gap-3">
        <div class="flex items-center gap-3 truncate text-black dark:text-white">
          <i class="fa-solid fa-badge-check text-green-500" />
          <span class="truncate">{json.domain}</span>
          <i class="fa-solid fa-lock" />
        </div>
        <span class="truncate text-gray-500">{json.name.trim() || "Name did'n provided"}</span>
      </div>
      <p class="font select-none truncate text-xs font-normal text-gray-200 sm:text-base">
        <i class="fa-solid fa-calendar-days" />
        &nbsp;&nbsp;{new Date(json.created).toString().slice(0, 24)}
      </p>
    </div>

    <div class="flex select-none justify-end">
      <a
        on:click={() => {
          $BadgePublish.reference = json.name
          $BadgePublish.domain = json.domain
          $BadgePublish.badgeId = json.id
          $BadgePublish.documentId = json.documentID
        }}
        name="tooltip"
        id="View Badge"
        tooltip-position="top"
        href="#/documents/badge/details?documentId={json.documentID}&badgeId={json.id}"
        type="button"
        class="flex items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-600 active:text-white disabled:cursor-not-allowed disabled:bg-none disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5"
      >
        <i class="fa-solid fa-eye" />
        <span class="hidden lg:block">&nbsp;&nbsp;View&nbsp;Badge&nbsp;</span>
      </a>
    </div>
  </div>
</div>

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
